import { useMemo } from 'react'

import { isEqual, union } from 'lodash'
import { cn, FormGroup, Label } from 'twyne-new.ui'

import { useGrid } from '@Components/Grid/context'
import { ResetFiltersButton } from '@Components/app-layout/SidebarFilters'

export default function Filters() {
  const { filters, showFilters, definitions, state: { setFilters, getFilter, filtersValues } } = useGrid()
  const defaultFilters = useMemo(() => definitions?.filters ?? {}, [definitions])
  const changedFilters = useMemo(
    () => union(Object.keys(filtersValues), Object.keys(defaultFilters)).filter(key => !isEqual(filtersValues[key], defaultFilters[key])),
    [filtersValues, defaultFilters],
  )
  const activeFiltersCount = changedFilters.length
  const isPristine = activeFiltersCount === 0

  const handleChangeFilters = (key, value) => {
    setFilters(({ [key]: _current, ...filters }) => {
      if ((Array.isArray(value) && value.length === 0) || value === null) {
        return filters
      }
      return { ...filters, [key]: value }
    })
  }

  const handleClearFilters = () => {
    setFilters({ ...defaultFilters })
  }

  return <div className={cn('grid w-full transition-[grid-template-rows] duration-300', showFilters ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]')}>
    <div className='overflow-hidden'>
      <div className='relative twy-bg-base w-full border-b twy-border-base flex flex-wrap gap-4 items-center p-4 max-md:grid max-md:grid-cols-2 max-md:gap-3 max-md:items-start'>
        {filters?.map(({ label, name, formatValue, Component, onChange, ...props }, index) => <FormGroup key={label} className={cn('min-w-[10%] max-w-full shrink-0 max-md:min-w-0', index === filters.length - 1 && filters.length % 2 && 'max-md:col-span-2')}>
          <Label>{label}</Label>
          <Component
            {...props}
            name={name}
            value={formatValue ? formatValue(getFilter(name)) : getFilter(name)}
            onChange={value => handleChangeFilters(name, onChange ? onChange(value) : value)}
          />
        </FormGroup>)}
        <ResetFiltersButton onReset={handleClearFilters} disabled={isPristine} count={activeFiltersCount} className='max-md:col-span-2 max-md:[&>label]:hidden max-md:[&_button]:w-full max-md:[&_button]:justify-center' />
      </div>
    </div>
  </div>
}
